import { TStatusSend } from "utils/InterfaceAndTypeGeneral";

export const initialStateAdmission = {
  admissionExamId: "",
  question: {
    score: 0,
    isLastQuestion: false,
    answers: [],
    id: "",
    content: "",
    order: 0,
  },
  quizId: "",
  remainingTime: 0,
  status: "NOT_DELIVERED",
  totalQuestions: 0,
};

export const initialStateSendQuestion = {
  questionId: "",
  answerId: "",
  sentBy: "CANDIDATE" as TStatusSend,
};
